import { ProvinceOrState } from './ProvinceOrState';

export enum ShipToEnum {
  FreightExtra = 'FREIGHT_EXTRA',
}

export type ShipTo = ProvinceOrState | ShipToEnum;
